import Shepherd from "shepherd.js";
import { tourChecker, addTourToQueue } from "@/lib/tour";

export const startTour = ({ check = true, options = {} } = {}) => {
  const tourName = "FilterManager";
  // console.warn("Started Tour of ", tourName);

  // If tour has been shown before and check is true, don't show it.
  if (check && tourChecker(tourName)) return;

  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    exitOnEsc: true,
    tourName,
    ...options,
  });

  /**
   * Adding Grid Property or Function
   */
  tour.addSteps([
    {
      attachTo: { element: ".entity-card .footer-add-button", on: "right" },
      advanceOn: {
        selector: ".entity-card .footer-add-button",
        event: "click",
      },
      popperOptions: {
        modifiers: [{ name: "offset", options: { offset: [15, 15] } }],
      },
      text: "You can Add more Entity Properties from here",
      buttons: [
        {
          text: "Skip",
          secondary: true,
          action: tour.complete,
        },
        {
          text: "Next",
          action: tour.next,
        },
      ],
    },
    {
      attachTo: { element: ".filter-manager", on: "left" },
      popperOptions: {
        modifiers: [{ name: "offset", options: { offset: [15, 15] } }],
      },
      text: "You can set filters on selected layer from here.",
      buttons: [
        {
          text: "Skip",
          secondary: true,
          action: tour.complete,
        },
        {
          text: "Back",
          secondary: true,
          action: tour.back,
        },
        {
          text: "Next",
          action: tour.next,
        },
      ],
    },
    {
      attachTo: { element: ".time-widget", on: "top" },
      popperOptions: {
        modifiers: [{ name: "offset", options: { offset: [15, 15] } }],
      },
      text: "Time data comes here",
      buttons: [
        {
          text: "Skip",
          secondary: true,
          action: tour.complete,
        },
        {
          text: "Back",
          secondary: true,
          action: tour.back,
        },
        {
          text: "Next",
          action: tour.next,
        },
      ],
    },
    {
      attachTo: { element: ".time-widget .window-selection", on: "top" },
      popperOptions: {
        modifiers: [{ name: "offset", options: { offset: [15, 15] } }],
      },
      text: "Filter data with time from here",
      buttons: [
        {
          text: "Skip",
          secondary: true,
          action: tour.complete,
        },
        {
          text: "Back",
          secondary: true,
          action: tour.back,
        },
        {
          text: "Next",
          action: tour.next,
        },
      ],
    },
    {
      attachTo: { element: ".legend-view", on: "bottom" },
      popperOptions: {
        modifiers: [{ name: "offset", options: { offset: [15, 15] } }],
      },
      text: "Legend View: add Range filter.",
      buttons: [
        {
          text: "Back",
          secondary: true,
          action: tour.back,
        },
        {
          text: "Done",
          action: tour.next,
        },
      ],
    },
  ]);

  addTourToQueue(tour, tourName);
};
